module.exports = new __parcel__URL__("create-team-avatar.a06263d8.svg").toString();